import React, { useEffect, useState } from "react";
import Slider from './SliderComponent';
import FavoritePerfumeSlider from './FavoritePerfumeSlider';
import './style.css';
import PerfumeSlider from './PerfumeSlider';
import HomePerfumeShowcase from "./HomePerfumeShowcase";
import BrandSlider from "./BrandSlider";
import FavoriteAccessories from './FavoriteAccessories';
import GetLatestReviews from './LatestReviews';
import HomeAccessoriesShowcase from "./HomeAccessoriesShowcase";
import GiftSetsSlider from "./sections/GiftSetsSlider";
import { useLanguage } from "./LanguageContext";

const HomePage = ({ addToCart }) => {
  const { t, language } = useLanguage();

    useEffect(() => {
    document.title = t("titles.category");
  }, [language]);


  return (
    <>
      <Slider />
      <FavoritePerfumeSlider addToCart={addToCart}/>
      <HomePerfumeShowcase  />
      <PerfumeSlider addToCart={addToCart}/>
      <HomeAccessoriesShowcase/>
      <FavoriteAccessories addToCart={addToCart}/>
      <GiftSetsSlider addToCart={addToCart}/>
      <GetLatestReviews />
      <BrandSlider titleKa="რჩეული ბრენდები" titleEn="Featured Brands" />
    </>
  );
};

export default HomePage;
